import React from "react";
import { IonCard, IonSkeletonText } from "@ionic/react";

const ProductCardSkeleton = () => {
  return (
    <IonCard className="flex flex-col gap-2 p-2 m-0 w-[11.3125rem] min-h-[17rem]">
      {/* Product Image Skeleton */}
      <IonSkeletonText animated className="w-full h-32 rounded-lg m-0" />

      {/* Product Name Skeleton */}
      <IonSkeletonText animated className="w-3/4 h-4 rounded-lg m-0" />

      <div className="flex flex-col gap-1">
        <IonSkeletonText animated className="w-4/4 h-4 rounded-lg m-0" />
        <IonSkeletonText animated className="w-2/4 h-4 rounded-lg m-0" />
      </div>

      {/* Price and Out of Stock Status */}
      <div className="flex flex-col gap-1 mt-auto">
        <IonSkeletonText animated className="w-1/2 h-4 rounded-lg m-0" />
        <IonSkeletonText animated className="w-2/3 h-4 rounded-lg m-0 opacity-60" />
      </div>
    </IonCard>
  );
};

export default ProductCardSkeleton;
